import { Button } from '@heroui/button';
import { Link } from 'react-router-dom';

import LazyImage from './lazy-image';

import { dataTech, edTech, quickAccess } from '@/assets/data/navbar';
import FacebookIcon from '@/assets/icons/FacebookIcon';
import LinkedInIcon from '@/assets/icons/LinkedInIcon';
import PlayStoreIcon from '@/assets/icons/PlayStoreIcon';
import YoutubeIcon from '@/assets/icons/YoutubeIcon';
import Logo from '@/assets/images/logo.svg';
import Site from '@/config/site';
import { cn } from '@/lib/utils';

export default function Footer() {
  return (
    <footer className="pt-10 bg-gradient-to-br from-white/5 to-white/0 border-t border-white/30">
      <div className={cn("grid grid-cols-1 lg:grid-cols-6 pb-10 container")}>
        <div className={cn("lg:col-span-2")}>
          <img alt={Site.APP_NAME} className="h-8 object-contain" src={Logo} />
          <div className="text-sm font-normal text-body mt-3">
            We’re committed to creating positive change around the world and
            ensuring we act as responsible business leaders for our people, our
            clients, and the communities we call home. Data here gives us wings
            to decide the next move which is disruptive and growth-centric.
          </div>
          <div className="text-sm font-normal text-body mt-3">
            Trade License: TRAD/DSCC/025220/2022
          </div>
        </div>
        <div
          className={cn(
            "md:pl-20 gap-5 mt-10 md:mt-0",
            "lg:col-span-4 grid grid-cols-2 md:grid-cols-2 lg:grid-cols-5",
          )}
        >
          <div className="col-span-1 lg:col-span-2">
            <h6 className="text-lg font-medium leading-relaxed text-title-secondary mb-4">
              Membership & Certification
            </h6>
            <img
              alt="BASIS Member"
              className="object-contain max-w-[250px] w-full mt-4"
              src="/assets/membershio-certifications.svg"
            />
            {/* <img
              alt="Dunenberg Member"
              className="object-contain max-w-[125px] w-full mt-4"
              src="/assets/dun-logo.svg"
            /> */}
          </div>
          <ListItem blank list={edTech.list} title={edTech.title} />
          <ListItem blank list={dataTech.list} title={dataTech.title} />
          <ListItem
            blank={false}
            list={quickAccess.list}
            title={quickAccess.title}
          />
        </div>
      </div>
      <div className="container mb-10">
        <LazyImage alt="Accepted Payment Methods" src="/assets/payment.png" />
      </div>
      <div className="border-t border-[#455468] mt-8">
        <div className="container py-8 flex flex-col lg:flex-row justify-between items-center gap-8">
          <p className="text-sm font-normal text-body text-center lg:text-left order-3 lg:order-1">
            © {new Date().getFullYear()}  Upscale BD. All rights reserved.
          </p>

          <div className="flex flex-col md:flex-row items-center gap-6 lg:gap-10 order-1 lg:order-2">
            <div className="flex items-center gap-2.5 text-body group cursor-pointer">
              <p className="text-sm font-normal text-center md:text-left max-w-[250px] md:max-w-none">
                House-25, Road-5, Block-J, Banasree, Rampura, Dhaka-1219
              </p>
            </div>
            <div className="flex items-center gap-3">
              {socialList.map((social, index) => (
                <Link
                  key={index}
                  aria-label="Link"
                  rel="noopener noreferrer"
                  target="_blank"
                  to={social.link}
                >
                  <Button
                    isIconOnly
                    aria-label="Link"
                    className="w-10 h-10 bg-[#2D3643] hover:bg-[#3D4857] hover:-translate-y-1 transition-all"
                    radius="full"
                  >
                    {social.icon}
                  </Button>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

type ListItem = {
  title: string;
  list: {
    label: string;
    link: string;
  }[];
  blank?: boolean;
};

const ListItem = ({ title, list, blank }: ListItem) => (
  <div>
    <h6 className="text-lg font-medium leading-relaxed text-title-secondary mb-4">
      {title}
    </h6>
    <ul>
      {list.map((el) => (
        <li key={el.label} className="text-base font-normal mb-3 last:mb-0">
          <Link
            className="text-body"
            rel={blank ? 'noopener noreferrer' : undefined}
            target={blank ? '_blank' : '_self'}
            to={el.link}
          >
            {el.label}
          </Link>
        </li>
      ))}
    </ul>
  </div>
);

const socialList = [
  {
    link: 'https://www.linkedin.com/company/upscalebd-ltd',
    icon: <LinkedInIcon />,
  },
  {
    link: 'https://www.facebook.com/profile.php?id=61576860683385',
    icon: <FacebookIcon />,
  },
  {
    link: 'https://www.youtube.com/@UpscaleBD',
    icon: <YoutubeIcon />,
  },
  // {
  //   link: "",
  //   icon: <TwitterIcon />,
  // },
  {
    link: 'https://play.google.com/store/apps/developer?id=UpscaleBD&hl=en',
    icon: <PlayStoreIcon />,
  },
  // {
  //   link: "",
  //   icon: <AppStoreIcon />,
  // },
];
